import {  Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './image-modal.component.html'
})

export class ImageModalComponent {
  @Input() imagemSelecionada;

  constructor(public activeModal: NgbActiveModal) {
  }
}
